<template>
    <div style="height: 100%;background: #ffffff;" class="flx">
        <el-row justify="start">
            标题：<el-input class="ipt" size="small" placeholder="请输入标题查询" v-model="form.title" clearable>
            </el-input>
            <el-button type="primary" class="btn" size="small" icon="el-icon-search" @click="getList()">搜索</el-button>
        </el-row>
        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="title" label="标题" width="auto">
            </el-table-column>
            <el-table-column prop="admin_name" label="编辑人" width="auto">
            </el-table-column>
            <el-table-column prop="updatetime" label="更新时间" width="auto">
            </el-table-column>
            <el-table-column prop="address" label="操作" width="280">
                <template slot-scope="scope">
                    <el-button size="small" type="primary" @click="toEdit(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 表格end -->
        <!-- 分页 -->
        <el-pagination class="fenye" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="form.page" :page-sizes="[10, 15, 20, 25]" :page-size="1"
            layout="total, sizes, prev, pager, next" :total="form.total">
        </el-pagination>
        <!-- 分页end -->
    </div>
</template>
<script>
import { lists } from '@/Api/Introduce/index.js'
export default {
    name: 'SystemIntroduce',
    data() {
        return {
            tableData: [],
            form: {
                page: 1,
                limit: 10,
                total: 0,
                title: ''
            },
        }
    },
    methods: {
        toEdit(row) {
            this.$router.push({
                path: '/introduceedit',
                query: {
                    id: row.id
                }
            })
        },

        getList() {
            lists(this.form).then(res => {
                if (res.code == 1) {
                    this.tableData = res.data.list
                    this.form.total = res.data.total
                }
            })
        },
        handleSizeChange(val) {
            this.form.limit = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.form.page = val
            this.getList()
        }
    },
    computed: {
    },
    created() {
        this.getList()
    }
}
</script>
<style lang="scss" scoped>
.introduce {
    width: 21rem;
    height: 12.4rem;
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
}
::v-deep .el-input {
  width: 400px;
}

::v-deep .el-textarea__inner {
  width: 400px;
}
::v-deep .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background-color: #ffffff;
}
.flx {
  height: calc(100vh - 60px) !important;
  padding: 20px 10px 30px 10px;
  overflow: scroll;
}
.zhanwei {
  margin: 15px 0;
}
.css {
  margin-left: 10px;
}
.border {
  height: 2px;
  background: #eeeeee;
  margin-bottom: 10px;
}

::v-deep .el-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.btn {
  margin-left: 50px;
  color: #ffffff;
}

.el-table {
  margin-top: 30px;
}
.ipt {
  width: 200px;
}
.fenye {
  text-align: right;
  margin-top: 30px;
}
.btnpermess {
  margin-right: 90px;
}
</style>
